import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "first-para grey-letters" }
const _hoisted_4 = { class: "grey-letters" }
const _hoisted_5 = { class: "grey-letters" }
const _hoisted_6 = { class: "button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.user)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[1] || (_cache[1] = _createElementVNode("h1", null, "User details", -1)),
          _createElementVNode("p", _hoisted_3, "Name: " + _toDisplayString(_ctx.user?.username?.split('@')[0]), 1),
          _createElementVNode("p", _hoisted_4, "Joined at: " + _toDisplayString(_ctx.user?.date_joined?.split('T')[0]), 1),
          _createElementVNode("p", _hoisted_5, "email: " + _toDisplayString(_ctx.user?.email), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.signOut && _ctx.signOut(...args))),
        class: "logout-btn"
      }, "Logout")
    ])
  ]))
}